import React from "react"

import {MoveTo_Manager} from "../../model/manager"
import SearchInput from "../../../../gd-ui/search/search"
import ModalMoveTo_SelectTaskFinder from "./move-to-task-main"
import {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import Modal_Submit from "../../../components/submit/submit"

type Props = {
    manager: MoveTo_Manager
}

// const debug = "ModalMoveTo_Task"
const debug = false

export default function ModalMoveTo_Task(props:Props) {

    const manager = props.manager

    const onSearchChange = (value: string) => {
        props.manager.setSearchPrompt(value)
    }

    const submitAvailable = manager.targetTask

    return (
        <div className="flex-column-top-stretch flex-1 min-h-0">
            <div className="p-h-20 m-b-20">
                <SearchInput value={manager.searchPrompt} onChange={onSearchChange}/>
            </div>

            <ModalMoveTo_SelectTaskFinder searchString      = {manager.searchPrompt}
                                          selectedProjectId = {manager.targetProject?.id}
                                          selectedTaskId    = {manager.targetTask?.id}
                                          excludedTasksIds  = {manager.affectedTasksIds}
                                          onClickTask       = {manager.setTargetTask}/>

            <Modal_Submit type      = {submitAvailable ? ButtonType.PRIMARY : ButtonType.DISABLED}
                          label     = "Submit"
                          onSubmit  = {submitAvailable ? manager.validateUsers : undefined}/>
        </div>
    )
}